export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_10b11c1c-fa1c-4226-b692-bc4f2bd57bb9/artifacts/ndjba9sc_Logo%20ohne%20Text%201.1.png";

export const IMAGES = {
  heroFamily:
    "https://images.unsplash.com/photo-1533777419517-3e4017e2e15a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxoYXBweSUyMGZhbWlseSUyMGVhdGluZyUyMGRpbm5lcnxlbnwwfHx8fDE3ODM4OTAxNDJ8MA&ixlib=rb-4.1.0&q=72&w=800",
  ingredients:
    "https://images.unsplash.com/photo-1706267701238-b4d69fc8f640?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxmcmVzaCUyMGZvb2QlMjBpbmdyZWRpZW50cyUyMHRvcCUyMHZpZXd8ZW58MHx8fHwxNzgzODkwMTQxfDA&ixlib=rb-4.1.0&q=72&w=800",
  fridge:
    "https://images.unsplash.com/photo-1643494847705-74808059bf07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxvcGVuJTIwZnJpZGdlJTIwZnVsbCUyMG9mJTIwaGVhbHRoeSUyMGZvb2R8ZW58MHx8fHwxNzgzODkwMTQyfDA&ixlib=rb-4.1.0&q=72&w=800",
  family:
    "https://images.unsplash.com/photo-1761839258568-fd466a93f68b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxmYW1pbHklMjBjb29raW5nJTIwdG9nZXRoZXIlMjBraXRjaGVuJTIwaGFwcHl8ZW58MHx8fHwxNzgzODkwMjI2fDA&ixlib=rb-4.1.0&q=72&w=800",
  pasta:
    "https://images.unsplash.com/photo-1777994505580-33478f04fa4a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxtZWRpdGVycmFuZWFuJTIwcGFzdGElMjBkaXNoJTIwdG9wJTIwdmlld3xlbnwwfHx8fDE3ODM4OTAyMjZ8MA&ixlib=rb-4.1.0&q=72&w=800",
  noodles:
    "https://images.unsplash.com/photo-1631709497146-a239ef373cf1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxhc2lhbiUyMG5vb2RsZSUyMGJvd2wlMjBjb2xvcmZ1bHxlbnwwfHx8fDE3ODM4OTAyMjZ8MA&ixlib=rb-4.1.0&q=72&w=800",
  salad:
    "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxoZWFsdGh5JTIwY29sb3JmdWwlMjBzYWxhZCUyMGJvd2wlMjBmcmVzaHxlbnwwfHx8fDE3ODM4OTAyMjZ8MA&ixlib=rb-4.1.0&q=72&w=800",
  swiss:
    "https://images.unsplash.com/photo-1654426927911-fb436e3ad209?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxzd2lzcyUyMGhvbWVtYWRlJTIwZGlubmVyJTIwcGxhdGUlMjBydXN0aWN8ZW58MHx8fHwxNzgzODkwMjI2fDA&ixlib=rb-4.1.0&q=72&w=800",
  gBreakfast:
    "https://images.unsplash.com/photo-1654923064926-be7e64267a31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxicmVha2Zhc3QlMjBib3dsJTIwYmVycmllcyUyMG9hdG1lYWx8ZW58MHx8fHwxNzkwMDIyMDA5fDA&ixlib=rb-4.1.0&q=72&w=800",
  gPizza:
    "https://images.unsplash.com/photo-1593560708920-61dd98c46a4e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxob21lbWFkZSUyMHBpenphJTIwd29vZGVuJTIwYm9hcmR8ZW58MHx8fHwxNzkwMDIyMDA5fDA&ixlib=rb-4.1.0&q=72&w=800",
  gCurry:
    "https://images.unsplash.com/photo-1612259980822-e13d828e1076?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxjcmVhbXklMjBjdXJyeSUyMHJpY2UlMjBib3dsfGVufDB8fHx8MTc5MDAyMjAwOXww&ixlib=rb-4.1.0&q=72&w=800",
  gTacos:
    "https://images.pexels.com/photos/27827766/pexels-photo-27827766.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=560&w=420",
  gSoup:
    "https://images.unsplash.com/photo-1603105037880-880cd4edfb0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxoZWFydHklMjB2ZWdldGFibGUlMjBzb3VwJTIwYm93bHxlbnwwfHx8fDE3OTAwMjIwMDl8MA&ixlib=rb-4.1.0&q=72&w=800",
  gDessert:
    "https://images.unsplash.com/photo-1517427294546-5aa121f68e8a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxjaG9jb2xhdGUlMjBkZXNzZXJ0JTIwY2FrZSUyMHNsaWNlfGVufDB8fHx8MTc5MDAyMjAwOXww&ixlib=rb-4.1.0&q=72&w=800"
};

export const FEATURES = [
  {
    icon: "ChefHat",
    title: "Gusti kocht Ideen",
    text: "Gusti schlägt dir passende Rezepte vor – abgestimmt auf eure Zutaten, Allergien und Vorlieben."
  },
  {
    icon: "Camera",
    title: "Zutaten per Foto",
    text: "Fotografiere deinen Kühlschrank oder Vorrat – die App erkennt deine Zutaten automatisch."
  },
  {
    icon: "Vote",
    title: "Live-Abstimmung",
    text: "Alle stimmen in Echtzeit ab. Seht sofort, wer mitmacht und welches Rezept gewinnt."
  },
  {
    icon: "Globe2",
    title: "Länderküchen",
    text: "Von Schweizerisch über Mediterran bis Asiatisch – wählt die Küche, auf die ihr Lust habt."
  },
  {
    icon: "Heart",
    title: "Rezepte speichern",
    text: "Sichere eure Lieblingsrezepte und findet sie jederzeit ganz einfach wieder."
  },
  {
    icon: "Users",
    title: "Haushalte & Gäste",
    text: "Erstelle einen Haushalt und lade Familie, WG oder Gäste bequem per Link ein."
  },
  {
    icon: "Salad",
    title: "Persönliches Essprofil",
    text: "Hinterlege Allergien, Ernährungsform und Vorlieben – für Vorschläge, die wirklich passen."
  },
  {
    icon: "MoonStar",
    title: "Heller & dunkler Modus",
    text: "Nutze die App so, wie es dir gefällt – im hellen oder dunklen Design."
  }
];

export const STEPS = [
  {
    n: "01",
    icon: "Users",
    title: "Haushalt erstellen & einladen",
    text: "Erstelle deinen Haushalt und hol Familie, WG oder Partner:in per Link dazu – z. B. direkt über WhatsApp."
  },
  {
    n: "02",
    icon: "Camera",
    title: "Zutaten & Küche wählen",
    text: "Tippe vorhandene Zutaten ein oder fotografiere einfach deinen Kühlschrank. Danach wählt ihr eure Länderküche und die passende Mahlzeit."
  },
  {
    n: "03",
    icon: "ChefHat",
    title: "Gusti schlägt Ideen vor",
    text: "Gusti schlägt euch drei passende Rezepte vor – ob Frühstück, Zmittag, Znacht oder Snack, jeweils mit appetitlichem Bild."
  },
  {
    n: "04",
    icon: "Vote",
    title: "Live abstimmen",
    text: "Alle stimmen in Echtzeit ab. Das Gericht mit den meisten Stimmen gewinnt – Lieblingsrezepte könnt ihr speichern."
  },
  {
    n: "05",
    icon: "CookingPot",
    title: "Kochmodus starten",
    text: "Startet den Schritt-für-Schritt-Kochmodus und kocht das Gewinner-Gericht ganz entspannt gemeinsam nach."
  },
  {
    n: "06",
    icon: "Utensils",
    title: "Gemeinsam geniessen",
    text: "Setzt euch zusammen an den Tisch und lasst es euch schmecken – vom Frühstück bis zum Znacht."
  }
];

export const FAQS = [
  {
    q: "Ist die App kostenlos?",
    a: "WasGitsHüt? kannst du kostenlos herunterladen und die wichtigsten Funktionen sofort nutzen."
  },
  {
    q: "Auf welchen Geräten läuft die App?",
    a: "Die App ist für iPhone (iOS) und Android-Smartphones verfügbar – lade sie im App Store oder bei Google Play herunter."
  },
  {
    q: "Wie funktioniert die Zutaten-Erkennung per Foto?",
    a: "Du fotografierst deinen Kühlschrank oder Vorrat, und die App erkennt die enthaltenen Zutaten automatisch und schlägt passende Rezepte vor."
  },
  {
    q: "Was passiert mit meinen Fotos?",
    a: "Deine Fotos werden ausschliesslich zur Zutaten-Erkennung genutzt, sofort danach verworfen und nirgendwo gespeichert."
  },
  {
    q: "Kann ich mit mehreren Personen zusammen entscheiden?",
    a: "Ja! Erstelle einen Haushalt, lade weitere Mitglieder ein und stimmt gemeinsam in Echtzeit ab, was gekocht wird."
  },
  {
    q: "Kann ich Allergien und Vorlieben hinterlegen?",
    a: "Ja. In deinem persönlichen Essprofil hinterlegst du Allergien, Ernährungsform und Vorlieben – die Rezeptvorschläge berücksichtigen das."
  }
];
